// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/shortcut_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { EmptySchema, FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/shortcut_service.proto.
 */
export const file_api_v1_shortcut_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask]);

/**
 * @generated from message journal.api.v1.Shortcut
 */
export type Shortcut = Message<"journal.api.v1.Shortcut"> & {
  /**
   * The resource name of the shortcut.
   * Format: users/{user}/shortcuts/{shortcut}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The title of the shortcut.
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * The filter expression for the shortcut.
   *
   * @generated from field: string filter = 3;
   */
  filter: string;
};

/**
 * Describes the message journal.api.v1.Shortcut.
 * Use `create(ShortcutSchema)` to create a new message.
 */
export const ShortcutSchema: GenMessage<Shortcut> = /*@__PURE__*/
  messageDesc(file_api_v1_shortcut_service, 0);

/**
 * @generated from message journal.api.v1.ListShortcutsRequest
 */
export type ListShortcutsRequest = Message<"journal.api.v1.ListShortcutsRequest"> & {
  /**
   * Required. The parent resource where shortcuts are listed.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;
};

/**
 * Describes the message journal.api.v1.ListShortcutsRequest.
 * Use `create(ListShortcutsRequestSchema)` to create a new message.
 */
export const ListShortcutsRequestSchema: GenMessage<ListShortcutsRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_shortcut_service, 1);

/**
 * @generated from message journal.api.v1.ListShortcutsResponse
 */
export type ListShortcutsResponse = Message<"journal.api.v1.ListShortcutsResponse"> & {
  /**
   * The list of shortcuts.
   *
   * @generated from field: repeated journal.api.v1.Shortcut shortcuts = 1;
   */
  shortcuts: Shortcut[];
};

/**
 * Describes the message journal.api.v1.ListShortcutsResponse.
 * Use `create(ListShortcutsResponseSchema)` to create a new message.
 */
export const ListShortcutsResponseSchema: GenMessage<ListShortcutsResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_shortcut_service, 2);

/**
 * @generated from message journal.api.v1.GetShortcutRequest
 */
export type GetShortcutRequest = Message<"journal.api.v1.GetShortcutRequest"> & {
  /**
   * Required. The resource name of the shortcut to retrieve.
   * Format: users/{user}/shortcuts/{shortcut}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.GetShortcutRequest.
 * Use `create(GetShortcutRequestSchema)` to create a new message.
 */
export const GetShortcutRequestSchema: GenMessage<GetShortcutRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_shortcut_service, 3);

/**
 * @generated from message journal.api.v1.CreateShortcutRequest
 */
export type CreateShortcutRequest = Message<"journal.api.v1.CreateShortcutRequest"> & {
  /**
   * Required. The parent resource where this shortcut will be created.
   * Format: users/{user}
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Required. The shortcut to create.
   *
   * @generated from field: journal.api.v1.Shortcut shortcut = 2;
   */
  shortcut?: Shortcut;

  /**
   * Optional. If set, validate the request, but do not actually create the shortcut.
   *
   * @generated from field: bool validate_only = 3;
   */
  validateOnly: boolean;
};

/**
 * Describes the message journal.api.v1.CreateShortcutRequest.
 * Use `create(CreateShortcutRequestSchema)` to create a new message.
 */
export const CreateShortcutRequestSchema: GenMessage<CreateShortcutRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_shortcut_service, 4);

/**
 * @generated from message journal.api.v1.UpdateShortcutRequest
 */
export type UpdateShortcutRequest = Message<"journal.api.v1.UpdateShortcutRequest"> & {
  /**
   * Required. The shortcut resource which replaces the resource on the server.
   *
   * @generated from field: journal.api.v1.Shortcut shortcut = 1;
   */
  shortcut?: Shortcut;

  /**
   * Optional. The list of fields to update.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message journal.api.v1.UpdateShortcutRequest.
 * Use `create(UpdateShortcutRequestSchema)` to create a new message.
 */
export const UpdateShortcutRequestSchema: GenMessage<UpdateShortcutRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_shortcut_service, 5);

/**
 * @generated from message journal.api.v1.DeleteShortcutRequest
 */
export type DeleteShortcutRequest = Message<"journal.api.v1.DeleteShortcutRequest"> & {
  /**
   * Required. The resource name of the shortcut to delete.
   * Format: users/{user}/shortcuts/{shortcut}
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.DeleteShortcutRequest.
 * Use `create(DeleteShortcutRequestSchema)` to create a new message.
 */
export const DeleteShortcutRequestSchema: GenMessage<DeleteShortcutRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_shortcut_service, 6);

/**
 * @generated from service journal.api.v1.ShortcutService
 */
export const ShortcutService: GenService<{
  /**
   * ListShortcuts returns a list of shortcuts for a user.
   *
   * @generated from rpc journal.api.v1.ShortcutService.ListShortcuts
   */
  listShortcuts: {
    methodKind: "unary";
    input: typeof ListShortcutsRequestSchema;
    output: typeof ListShortcutsResponseSchema;
  },
  /**
   * GetShortcut gets a shortcut by name.
   *
   * @generated from rpc journal.api.v1.ShortcutService.GetShortcut
   */
  getShortcut: {
    methodKind: "unary";
    input: typeof GetShortcutRequestSchema;
    output: typeof ShortcutSchema;
  },
  /**
   * CreateShortcut creates a new shortcut for a user.
   *
   * @generated from rpc journal.api.v1.ShortcutService.CreateShortcut
   */
  createShortcut: {
    methodKind: "unary";
    input: typeof CreateShortcutRequestSchema;
    output: typeof ShortcutSchema;
  },
  /**
   * UpdateShortcut updates a shortcut for a user.
   *
   * @generated from rpc journal.api.v1.ShortcutService.UpdateShortcut
   */
  updateShortcut: {
    methodKind: "unary";
    input: typeof UpdateShortcutRequestSchema;
    output: typeof ShortcutSchema;
  },
  /**
   * DeleteShortcut deletes a shortcut for a user.
   *
   * @generated from rpc journal.api.v1.ShortcutService.DeleteShortcut
   */
  deleteShortcut: {
    methodKind: "unary";
    input: typeof DeleteShortcutRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_shortcut_service, 0);

